/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MultipleReturnGetSessionsDto } from '../../models/multiple-return-get-sessions-dto';

export interface ApiSessionsGet$Params {
    /**
     * Query helper
     */
    query?: string;

    /**
     * Populate user
     */
    populateUser?: boolean;
}

export function apiSessionsGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiSessionsGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<MultipleReturnGetSessionsDto>> {
    const rb = new RequestBuilder(rootUrl, apiSessionsGet.PATH, 'get');
    if (params) {
        rb.query('query', params.query, {});
        rb.query('populateUser', params.populateUser, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<MultipleReturnGetSessionsDto>;
        }),
    );
}

apiSessionsGet.PATH = '/api/sessions';
